import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=bcf6e190"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=bcf6e190&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports